import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Modal, Icon, Text, Upload, Button, Input } from '@atomic';
import { ReactComponent as PostSvg } from '@assets/icon/icn_post.svg';
import { CloseIcn } from '@assets/icon';
import { COLOR_BORDER } from '@assets/color';
import { uploadProfileApi } from '@api/AccountApiList';
import { uploadUserInfoApi } from '@api/AccountApiList';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 20px;
`;

const ImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100px;
  height: 100px;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
`;

const IdContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  width: 100%;
  margin: 0 0 20px;
  gap: 10px;
`;

const ModalEditProfile = ({ onClose, ...props }) => {
  const imgRef = useRef(null);
  const [profile, setProfile] = useState({
    image: null,
    fullName: null,
  });

  const handleChangeImg = (file) => {
    setProfile({
      ...profile,
      image: file,
    });

    const preview = new FileReader();
    preview.readAsDataURL(file);
    preview.onload = () => {
      imgRef && (imgRef.current.src = preview.result);
    };
  };

  const handleChangeFullName = (e) => {
    setProfile({
      ...profile,
      fullName: e.target.value,
    });
  };

  const handleClose = () => {
    onClose && onClose();
  };

  const handleEditProfile = async () => {
    const profileImgFormData = new FormData();

    profileImgFormData.append('isCover', false);
    profileImgFormData.append('image', profile.image);

    try {
      profile.image && (await uploadProfileApi(profileImgFormData));
      profile.fullName &&
        (await uploadUserInfoApi({
          fullName: profile.fullName,
          username: '',
        }));

      handleClose();
    } catch (e) {
      console.log('프로필 이미지 또는 사용자 이름 변경에 실패했습니다.', e);
    }
  };

  return (
    <Modal
      style={{ padding: '20px' }}
      {...props}
      onClose={onClose}
      width="295px"
      height="380px"
    >
      <Icon src={CloseIcn} clickable iconSize={20} onClick={handleClose} />
      <ContentWrapper onClick={(e) => e.stopPropagation()}>
        <Text strong textSize={18}>
          Edit Profile
        </Text>
        <Upload
          droppable
          accept="img/*"
          onChange={handleChangeImg}
          width="100px"
          height="100px"
          style={{ borderRadius: '100%' }}
        >
          {(file) => (
            <>
              {file ? (
                <Img
                  ref={imgRef}
                  alt="이미지 업로더"
                  style={{ borderRadius: '100%' }}
                />
              ) : (
                <ImgContainer>
                  <PostSvg className="posting-icn" />
                </ImgContainer>
              )}
            </>
          )}
        </Upload>
        <IdContainer>
          <Text textSize={14}>아이디</Text>
          <Input
            inputType="form"
            style={{ border: `1px solid ${COLOR_BORDER}` }}
            onChange={handleChangeFullName}
          />
        </IdContainer>
        <Button onClick={handleEditProfile} width="170px">
          Edit
        </Button>
      </ContentWrapper>
    </Modal>
  );
};

ModalEditProfile.propTypes = {
  onClose: PropTypes.func,
  editProfile: PropTypes.func,
};

export default ModalEditProfile;
